import { createAction } from '@ngrx/store';

export enum RootActionsTypes {
    RESET = '[Root State] Reset'
}

export const reset = createAction(RootActionsTypes.RESET);
